import React from "react";
import { Autocomplete, TextField, InputAdornment, IconButton } from "@mui/material";
import SearchIcon from "@mui/icons-material/Search";

const SearchBar = ({
  searchKey = [],
  searchTerm = "",
  handleOnSelect,
  handleOnSearch,
  handleFocus,
  placeholder = "Search...",
  handleSearchClick, // new optional prop
}) => {
  return (
    <Autocomplete
      freeSolo
      options={searchKey.map((option) => option.title)}
      inputValue={searchTerm}
      onInputChange={(event, newInputValue) => {
        handleOnSearch(newInputValue);
      }}
      onChange={(event, value) => {
        const selected = searchKey.find((item) => item.title === value);
        if (selected) {
          handleOnSelect(selected);
        }
      }}
      onFocus={handleFocus}
      renderInput={(params) => (
        <TextField
          {...params}
          placeholder={placeholder}
          variant="outlined"
          size="small"
          inputProps={{
            ...params.inputProps,
            maxLength: 100,
          }}
          sx={{
            '& .MuiOutlinedInput-root': {
              border: '1px solid rgb(223, 225, 229)',
              borderRadius: '24px',
              backgroundColor: 'white',
              color: 'rgb(33, 33, 33)',
            },
            '& .MuiOutlinedInput-notchedOutline': {
              border: 'none',
            },
          }}
          InputProps={{
            ...params.InputProps,
            endAdornment: (
              <InputAdornment position="end">
                <IconButton onClick={handleSearchClick}>
                  <SearchIcon />
                </IconButton>
              </InputAdornment>
            ),
          }}
        />
      )}
      className="navSearchbar"
    />
  );
};

export default SearchBar;
